import { t } from 'i18next'

import { DeliveryMethodDTO } from '../../common/types.js'
import { TextfieldProps } from '../components/forms/textfield/textfield.js'
import { View } from '../types.js'
import { translateWithFallback } from '../utils/utils.js'

export class DeliveryMethod {
    readonly data: DeliveryMethodDTO

    constructor(deliveryMethod: DeliveryMethodDTO) {
        this.data = deliveryMethod
    }

    get uuid() {
        return this.data.uuid
    }

    get code() {
        return this.data.type.toLowerCase() || ''
    }

    get title() {
        return translateWithFallback(`sign.deliveryMethods.${this.code}.name`, this.code)
    }

    get description() {
        return translateWithFallback(`sign.deliveryMethods.${this.code}.description`, '')
    }

    get name() {
        return translateWithFallback(`sign.deliveryMethods.${this.code}.cartTitle`, this.code)
    }

    get price() {
        return translateWithFallback(`sign.deliveryMethods.${this.code}.price`, '-')
    }

    getAdditionalFields(view: View): TextfieldProps[] {
        if (!view.state.formData.differentShippingAddress) {
            return []
        }

        return [
            {
                id: 'shipping-postalcode',
                name: 'postalcode',
                label: t('sign.postalCode'),
                error: view.state.formErrors.shippingPostalCode ? t('sign.errors.postalCode') : undefined,
                value: view.state.formData.shippingPostalCode,
                type: 'text',
                isRequired: true,
                onChange: (value) => {
                    view.state.formData.shippingPostalCode = value
                    view.update()
                },
            },
            {
                id: 'shipping-address',
                name: 'address',
                label: t('sign.address'),
                error: view.state.formErrors.shippingAddress ? t('sign.errors.address') : undefined,
                value: view.state.formData.shippingAddress,
                type: 'text',
                isRequired: true,
                onChange: (value) => {
                    view.state.formData.shippingAddress = value
                    view.update()
                },
            },
            {
                id: 'shipping-city',
                name: 'city',
                label: t('sign.city'),
                error: view.state.formErrors.shippingCity ? t('sign.errors.city') : undefined,
                value: view.state.formData.shippingCity,
                type: 'text',
                isRequired: true,
                onChange: (value) => {
                    view.state.formData.shippingCity = value
                    view.update()
                },
            },
        ]
    }
}
